var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  "dismiss": `Elutas\xedt\xe1s`
};
export { $74cf411061b983a2$exports as default };